var CoordsValidation = /** @class */ (function () {
    function CoordsValidation() {
    }
    CoordsValidation.validate = function (control) {
        var value = control.value;
        var regex = '^-?\d+(\.\d+)?$';
        if (!value || value < -180 || value > 180 || value.toString().match(regex)) {
            return { invalidCoords: true };
        }
        return null;
    };
    return CoordsValidation;
}());
export { CoordsValidation };
